const titleWrappers = document.querySelectorAll('.footer__title-wrapper');

if (!titleWrappers) return;

//open 1st accordion bt default
titleWrappers[0].parentElement.classList.add('footer__menu-accordion-open');
        
titleWrappers.forEach(titleWrapper => {
    titleWrapper.addEventListener('click', function() {
        const parent = this.parentElement;
        
        // Close all menus
        titleWrappers.forEach(wrapper => {
            wrapper.parentElement.classList.remove('footer__menu-accordion-open');
        });

        // Toggle the clicked menu
        parent.classList.toggle('footer__menu-accordion-open');
    });
});